import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const wasteGroupingContractRoutes = ({
  WasteGroupingContract,
  AddWasteGroupingContract,
  UpdateWasteGroupingContract,
}: {
  WasteGroupingContract: React.ComponentType;
  AddWasteGroupingContract: React.ComponentType;
  UpdateWasteGroupingContract: React.ComponentType;
}) => (
  <Routes>
    <Route path="" element={<WasteGroupingContract />} />
    <Route path={ROUTES.MASTER_DATA.WASTE_GROUP_CONTRACT.CREATE} element={<AddWasteGroupingContract />} />
    <Route path={ROUTES.MASTER_DATA.WASTE_GROUP_CONTRACT.EDIT} element={<UpdateWasteGroupingContract />} />
  </Routes>
);

